import React, { useState } from 'react';
import { bookingApi } from '../utils/bookingApi';

// Competition gender for a gymnast. Saves as soon as it changes, so it can sit
// inline on profile pages and the competition invite list.
export const GENDER_OPTIONS = [
  { value: '', label: 'Not set' },
  { value: 'FEMALE', label: 'Girls' },
  { value: 'MALE', label: 'Boys' },
];

export default function GenderSelect({ gymnastId, value, onSaved, id }) {
  const [current, setCurrent] = useState(value || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const selectId = id || `gender-${gymnastId}`;

  const change = async (e) => {
    const next = e.target.value;
    const previous = current;
    setCurrent(next);
    setSaving(true);
    setError(null);
    try {
      await bookingApi.updateGymnast(gymnastId, { gender: next || null });
      onSaved?.(next || null);
    } catch (err) {
      setCurrent(previous);
      setError(err.response?.data?.error || 'Could not save');
    } finally {
      setSaving(false);
    }
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', flexWrap: 'wrap' }}>
      <label htmlFor={selectId} style={{ fontSize: '0.8rem' }}>Competes as</label>
      <select id={selectId} className="bk-input" style={{ width: 'auto', fontSize: '0.82rem', padding: '0.2rem 0.4rem' }}
        value={current} onChange={change} disabled={saving}>
        {GENDER_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {error && <span role="alert" style={{ color: 'var(--booking-danger)', fontSize: '0.75rem' }}>{error}</span>}
    </span>
  );
}
